import { Action, ActionType, RecordState } from '../types';
import {
  dropFromLaidToHome,
  dropFromLaidToLaid,
  dropFromLaidToSlots,
  dropFromSlotsToHome,
  dropFromSlotsToLaid,
  dropFromSlotsToSlots,
  increaseHintNumber,
  newGame,
  restartGame,
  setListening,
  showCardsOverflowMessage,
  toggleModal,
  undo,
} from './fn';
import { getCardsRenderInfo } from '../../utils';

export default function reducer(state: RecordState, action: Action | any): RecordState {
  const { type, payload } = action;

  switch (type) {
    case ActionType.DropFromLaidToLaid: {
      const newState = dropFromLaidToLaid(state, action);
      localStorage.setItem('__free__cell__v1__state', JSON.stringify(newState));
      return newState;
    }

    case ActionType.DropFromLaidToSlots: {
      const newState = dropFromLaidToSlots(state, action);
      localStorage.setItem('__free__cell__v1__state', JSON.stringify(newState));
      return newState;
    }

    case ActionType.DropFromSlotsToSlots: {
      const newState = dropFromSlotsToSlots(state, action);
      localStorage.setItem('__free__cell__v1__state', JSON.stringify(newState));
      return newState;
    }

    case ActionType.DropFromSlotsToLaid: {
      const newState = dropFromSlotsToLaid(state, action);
      localStorage.setItem('__free__cell__v1__state', JSON.stringify(newState));
      return newState;
    }

    case ActionType.DropFromLaidToHome: {
      const newState = dropFromLaidToHome(state, action);
      localStorage.setItem('__free__cell__v1__state', JSON.stringify(newState));
      return newState;
    }

    case ActionType.DropFromSlotsToHome: {
      const newState = dropFromSlotsToHome(state, action);
      localStorage.setItem('__free__cell__v1__state', JSON.stringify(newState));
      return newState;
    }

    case ActionType.SetListening: {
      const newState = setListening(state, payload.listening);
      localStorage.setItem('__free__cell__v1__state', JSON.stringify(newState));
      return newState;
    }

    case ActionType.Undo: {
      const newState = undo(state);
      localStorage.setItem('__free__cell__v1__state', JSON.stringify(newState));
      return newState;
    }

    case ActionType.ToggleModal: {
      const newState = toggleModal(state, payload.name);
      localStorage.setItem('__free__cell__v1__state', JSON.stringify(newState));
      return newState;
    }

    case ActionType.NewGame: {
      const newState = newGame(state);
      localStorage.setItem('__free__cell__v1__state', JSON.stringify(newState));
      return newState;
    }

    case ActionType.RestartGame: {
      const newState = restartGame(state);
      localStorage.setItem('__free__cell__v1__state', JSON.stringify(newState));
      return newState;
    }

    case ActionType.ShowCardsOverflowMessage: {
      const newState = showCardsOverflowMessage(state, action);
      localStorage.setItem('__free__cell__v1__state', JSON.stringify(newState));
      return newState;
    }

    case ActionType.IncreaseHintNumber: {
      const newState = increaseHintNumber(state);
      localStorage.setItem('__free__cell__v1__state', JSON.stringify(newState));
      return newState;
    }

    case ActionType.SetOrientation: {
      const size = payload.contentWidth;

      return state
        .set('size', size)
        .set('cardsRenderInfo', getCardsRenderInfo(size))
        .set('orientation', payload.orientation);
    }

    case ActionType.ChangeScores: {
      return state.updateIn(['gameData', 'scores'], x => Math.max(0, x + payload.scores));
    }

    case ActionType.ChangeVolume: {
      const newState = state.update('volume', volume => !volume);
      localStorage.setItem('__free__cell__v1__state', JSON.stringify(newState));
      return newState;
    }

    default: {
      return state;
    }
  }
}
